import React, { useContext, useState, useEffect } from 'react'
import { LogoImage, SearchImage } from '../../Constant/AppConstant'
import { HALL_CONSTANT_DATA } from '../../Constant/AreaOptionData';
import { SectionData } from '../../Constant/SectionData';
import { SearchContext } from '../../Context/SearchContextProvider'
import style from './index.module.css'
import { MyDropDown } from "../MyDropDown"
import { isMobile } from 'react-device-detect';
import { BiUpArrow } from 'react-icons/bi';
import { FiChevronDown } from 'react-icons/fi';

const SPONSORS = [
    { src: "/assets/images/aczelSponser.svg", alt: "Aczet", href: "https://www.aczet.com" },
    { src: "/assets/images/lotusSponser.svg", alt: "The Lotus Impex", href: "https://www.thelotusimpex.com" },
    { src: "/assets/images/doitSponser.svg", alt: "DoIT Industries", href: "https://doitindustries.com/" },
    { src: "/assets/images/riddhiSponser.svg", alt: "Riddhi Heatron", href: "https://www.riddhiheatron.com" },
];

export default function MainLayout(props) {
    const { currentSearchList, updateSellersData, search, clearSearch, zoomToStall, _data, setStallId } = useContext(SearchContext);
    const [searchTxt, setSearchTxt] = useState("");
    const { setAreaFilterId, setSectionFilterId } = useContext(SearchContext);
    const [filterPanelOpen, setFilterPanelOpen] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null); // "area" | "section" | null
    const [venueMenuOpen, setVenueMenuOpen] = useState(false);

    const openFilters = () => {
        setStallId(null); // dismiss stall popup so the sheet is on top
        setFilterPanelOpen(true);
    };

    const closeFilters = () => {
        setFilterPanelOpen(false);
    };

    const toggleFilters = () => {
        if (filterPanelOpen) {
            closeFilters();
        } else {
            openFilters();
        }
    };

    useEffect(() => {
        if (searchTxt.length === 0) {
            clearSearch();
            return;
        }
        // Wait until stall data is loaded — still keep the typed value responsive
        if (Object.keys(_data.current.sellerData).length === 0) {
            return;
        }
        search(searchTxt);
    }, [searchTxt])

    useEffect(() => {
        if (!filterPanelOpen) {
            setOpenDropdown(null);
        }
    }, [filterPanelOpen])

    return (
        <div className={`${style.mainContainer} ${props.needBackground ? style.mainContainer_bg : ""}`}>

            <div className={style.header} style={!props.needSearch ? {
                justifyContent: 'flex-end'
            } : {}}>
                {
                    props.needSearch &&
                    <div className={style.leftHeaderContianre}>
                        <div
                            className={style.searchBoxConatainer}
                            onClick={(e) => {
                                const input = e.currentTarget.querySelector("input");
                                if (input) {
                                    input.focus();
                                }
                            }}
                        >
                            <img className={style.searchBoxIcon} src={SearchImage} alt="" aria-hidden="true" />
                            <input
                                className={style.searchBox}
                                type="search"
                                enterKeyHint="search"
                                autoComplete="off"
                                placeholder="Search for stalls"
                                onChange={(event) => {
                                    setSearchTxt(event.target.value)
                                }}
                                value={searchTxt}
                            />
                            {
                                currentSearchList &&
                                <div className={style.search_result_conatiner}>
                                    {
                                        currentSearchList.map((_stallData, index) => {
                                            let locData = _stallData.stallData[Object.keys(_stallData.stallData)[0]]
                                            return (
                                                <div key={index} className={style.search_result}>
                                                    <div className={style.NameContainer}>
                                                        <span>
                                                            {
                                                                _stallData.company_name
                                                            }
                                                        </span>
                                                        <span>
                                                            {
                                                                locData &&
                                                                HALL_CONSTANT_DATA[locData.hallNo]
                                                            }
                                                        </span>
                                                    </div>
                                                    <div className={style.stallNoContainer}>
                                                        Stall No.: {locData.stallId}
                                                    </div>
                                                    <div className={style.sectionContainer}>
                                                        Section: {SectionData[_stallData.section]}
                                                    </div>
                                                    <div>
                                                        <button className={style.stallBtn} onClick={(e) => {
                                                            e.preventDefault();
                                                            zoomToStall(locData.stallId);
                                                            setSearchTxt("")
                                                        }}>
                                                            View More &gt;
                                                        </button>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            }
                        </div>
                        <div className={style.filterWrap}>
                            <button
                                type="button"
                                className={style.filterToggleBtn}
                                aria-label={filterPanelOpen ? "Close filters" : "Open filters"}
                                onClick={(e) => {
                                    e.preventDefault();
                                    toggleFilters();
                                }}
                            >
                                <img
                                    src={filterPanelOpen ? "/assets/images/closeIcon.svg" : "/assets/images/filterIcon.svg"}
                                    alt={filterPanelOpen ? "close filters" : "open filters"}
                                    className={filterPanelOpen ? style.closeIcon : style.filterIcon}
                                />
                            </button>
                            <div
                                className={`${style.filterBackdrop} ${filterPanelOpen ? style.filterBackdropVisible : ""}`}
                                onClick={closeFilters}
                                aria-hidden={!filterPanelOpen}
                            />
                            <div
                                className={`${style.filterContainer} ${filterPanelOpen ? style.filterContainerOpen : ""}`}
                                role="dialog"
                                aria-label="Filters"
                                aria-hidden={!filterPanelOpen}
                            >
                                <button
                                    type="button"
                                    className={style.filterSheetClose}
                                    aria-label="Close filters"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        closeFilters();
                                    }}
                                >
                                    <FiChevronDown />
                                </button>
                                <p className={style.filterSheetTitle}>Filters</p>
                                <div className={style.filterSheetBody}>
                                <MyDropDown
                                    nested
                                    // className={style.MyDropDown}
                                    isOpen={openDropdown === "area"}
                                    onOpenChange={(open) => setOpenDropdown(open ? "area" : null)}
                                    onChnage={(option) => {
                                        if (option) {
                                            setAreaFilterId(option.value);
                                            closeFilters();
                                        }
                                    }}
                                >
                                    {
                                        (selectedOption) => !selectedOption.value ?
                                            "Area "
                                            :
                                            `${isMobile ? "A" : "Area"}: ${selectedOption.label}`
                                    }
                                </MyDropDown>
                                <MyDropDown
                                    nested
                                    className={style.seachDropDown}
                                    autoWidth
                                    isOpen={openDropdown === "section"}
                                    onOpenChange={(open) => setOpenDropdown(open ? "section" : null)}
                                    options={
                                        [
                                            { value: null, label: "All" },
                                            { value: "sectionData_1", label: "Diamond, Gemstone & Other Studded Jewellery" },
                                            { value: "sectionData_2", label: "Gold & Gold CZ Studded Jewellery" },
                                            { value: "sectionData_3", label: "Silver Jewellery, Artifacts & Gifting Items" },
                                            { value: "sectionData_4", label: "Laboratories and Education" },
                                            { value: "sectionData_5", label: "Lab Grown Diamonds (Loose)" },
                                            { value: "sectionData_6", label: "Lab Grown Jewellery" },
                                            { value: "sectionData_7", label: "International jewellery" },
                                            { value: "sectionData_11", label: "Allied" },
                                            { value: "sectionData_12", label: "Machinery" },
                                            { value: "sectionData_13", label: "International Machinery" },
                                            {value: "sectionData_17", label: "International Allied"},
                                            // { value: "sectionData_8", label: "Loose stone (Colour stone)" },
                                            // { value: "sectionData_9", label: "The Select Club" }, // old (pre floorMap update)
                                            { value: "sectionData_9", label: "The Select Club" },
                                            { value: "sectionData_10", label: "Loose Stones Diamonds" },
                                        ]
                                    }
                                    onChnage={(option) => {
                                        if (option) {
                                            setSectionFilterId(option.value);
                                            closeFilters();
                                        }
                                    }}
                                >
                                    {
                                        (selectedOption) => !selectedOption.value ?
                                            "Section"
                                            :
                                            `${isMobile ? "S" : "Section"}: ${selectedOption.label}`
                                    }
                                </MyDropDown>
                                </div>
                            </div>
                        </div>
                        <div className={style.venueDropDownWrap}>
                            <button
                                type="button"
                                className={style.venueDropDownBtn}
                                aria-label="Choose venue"
                                aria-expanded={venueMenuOpen}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setVenueMenuOpen((prev) => !prev);
                                    setFilterPanelOpen(false);
                                }}
                            >
                                <span className={style.venueBtnLabel}>Choose Venue</span>
                                <img
                                    src="/assets/images/locationIcon.svg"
                                    alt=""
                                    className={style.venueMobileIcon}
                                />
                                <BiUpArrow
                                    className={style.venueChevron}
                                    style={venueMenuOpen ? {
                                        transform: "rotate(0deg)"
                                    } : {
                                        transform: "rotate(180deg)"
                                    }}
                                />
                            </button>
                            <div className={`${style.venueMenu} ${venueMenuOpen ? style.venueMenuOpen : ""}`}>
                                <div className={`${style.venueMenuItem} ${style.venueMenuItemCurrent}`}>
                                    <span>BEC - NESCO</span>
                                    <img src="/assets/images/locationIcon.svg" alt="current venue" className={style.venueItemIcon} />
                                </div>
                                <a
                                    href="https://iijs-signature-jasmine.web.app/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={style.venueMenuItem}
                                >
                                    <span>Jasmine & Lotus Hall</span>
                                    <img src="/assets/images/externalLinkIcon.svg" alt="" className={style.venueItemIcon} />
                                </a>
                                <a
                                    href="https://iijs-signature-jwcc.web.app/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={style.venueMenuItem}
                                >
                                    <span>Pavilion Hall</span>
                                    <img src="/assets/images/externalLinkIcon.svg" alt="" className={style.venueItemIcon} />
                                </a>
                            </div>
                        </div>
                        <div className={style.sponserContainer}>
                            {SPONSORS.map((sponsor) => (
                                <a
                                    key={sponsor.href}
                                    className={style.logoWrapper}
                                    href={sponsor.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={sponsor.alt}
                                >
                                    <img src={sponsor.src} alt={sponsor.alt} />
                                </a>
                            ))}
                        </div>
                    </div>

                }
                <img src={LogoImage} alt={"logoImage"} />
                {
                    props.needSearch &&
                    <div className={style.mobileSponsorStrip} aria-label="Sponsors">
                        <div className={style.mobileSponsorTrack}>
                            {SPONSORS.map((sponsor) => (
                                <a
                                    key={sponsor.href}
                                    className={style.mobileSponsorItem}
                                    href={sponsor.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={sponsor.alt}
                                >
                                    <img src={sponsor.src} alt={sponsor.alt} />
                                </a>
                            ))}
                        </div>
                    </div>
                }
            </div>

            <div className={style.childrenContainer}>
                {props.children}
            </div>
        </div >
    )
}
